import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import SponsorshipViewDialogHeader from './SponsorshipViewDialogHeader';
import api from '@/utils/apiClient';
import LoadingIcon from 'mdi-react/LoadingIcon';
import SanitizeHTML from '@/shared/components/SanitizeHTML';
import moment from 'moment';

const SponsorshipViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal] = useState({
    isOpen: show,
    title: 'View Sponosrship',
    hide: onHide,
  });

  const [state, setState] = useState({
    loading: true,
    sponsorship: {},
    error: '',
  });

  useEffect(() => {
    if (id) getSponsorshipById(+id);
  }, [id]);

  const getSponsorshipById = async (id) => {
    try {
      const { data: res, isSuccess } = await api.cadsAISponsorship.getSponsorshipById(id);
      if (id) {
        setState({ ...state, loading: false, sponsorship: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting sponsorship details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, sponsorship: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, sponsorship } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <SponsorshipViewDialogHeader modal={modal} sponsorship={sponsorship} />
      {/* Sponosrship Modal Body */}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting sponsorship details...' : error}
            </div>
          </>
        ) : (
          <table className="project-summary__info">
            <tr>
              <th>Image</th>
              <td>
                <img
                  style={{ height: 100, width: 100 }}
                  alt={'sponsorship-img'}
                  src={sponsorship.imageThumbnail ? sponsorship.imageThumbnail : null}
                />
              </td>
            </tr>
            <tr>
              <th>Title</th>
              <td>{sponsorship?.title}</td>
            </tr>
            <tr>
              <th>Slug</th>
              <td>{sponsorship?.slug}</td>
            </tr>
            <tr>
              <th>Description</th>
              <td>
                <div className="question-extra-html">
                  <SanitizeHTML html={sponsorship.description ?? '<p/>'} />
                </div>
              </td>
            </tr>
            <tr>
              <th>Tags</th>
              <td>{sponsorship?.tag ?? '-'}</td>
            </tr>
            <tr>
              <th>Boost Score</th>
              <td>{sponsorship?.boostScore ?? '-'}</td>
            </tr>
            <tr>
              <th>Read Count</th>
              <td>{sponsorship?.readCount ?? '-'}</td>
            </tr>
            <tr>
              <th>Followed Count</th>
              <td>{sponsorship?.followedCount ?? '-'}</td>
            </tr>
            <tr>
              <th>Link</th>
              <td>
                <a href={sponsorship?.link} target="_blank">
                  {sponsorship?.link}
                </a>
              </td>
            </tr>
            <tr>
              <th>Is Published</th>
              <td>{sponsorship?.isPublished ? 'Yes' : 'No'}</td>
            </tr>
            <tr>
              <th>Publish Date</th>
              <td>
                {sponsorship?.publishDate
                  ? moment(sponsorship?.publish_date).format('DD/MM/yyyy')
                  : '-'}
              </td>
            </tr>
            <tr>
              <th>Status</th>
              <td>{sponsorship.status ? 'Active' : 'Inactive'}</td>
            </tr>
          </table>
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(SponsorshipViewDialog);
